import styled from 'styled-components';
import { v2Color } from '@theme/v2';

export const Row = styled.div`
  display: flex;
  flex-direction: ${(p) => (p.$isMobile ? 'column' : 'row')};
  align-items: ${(p) => (p.$isMobile ? 'stretch' : 'center')};
  gap: ${(p) => (p.$isMobile ? '12px' : '16px')};
  padding: 14px;
  background: #fff;
  border: 1px solid #edeff2;
  border-radius: 8px;
`;

export const Main = styled.div`
  display: grid;
  gap: 10px;
  min-width: 0;
  flex: 1;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
`;

export const LicenseNumber = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${v2Color('#272B41', 'text')};
  white-space: nowrap;
`;

export const Chip = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${v2Color('#F4F5F7')};
  color: rgb(112, 112, 112);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Meta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => p.$gap ?? 5}px;
  color: ${(p) => p.$color ?? 'rgb(112, 112, 112)'};
  font-size: 13px;
`;

export const AvatarImage = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
`;

export const AvatarFallback = styled.span`
  display: inline-grid;
  place-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f1f3f7;
  color: rgb(130, 130, 130);
  font-size: 10px;
  font-weight: 700;
  flex: 0 0 auto;
`;

export const UnassignedAvatar = styled.span`
  display: inline-grid;
  place-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f1f3f7;
  flex: 0 0 auto;
`;

export const UnassignedDash = styled.span`
  width: 8px;
  height: 2px;
  border-radius: 1px;
  background: rgb(170, 170, 170);
`;

export const MobilePrice = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${v2Color('#272B41', 'text')};
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  ${(p) => p.$isMobile && 'width: 100%;'}
`;

export const DesktopPrice = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${v2Color('#272B41', 'text')};
  white-space: nowrap;
`;

export const ViewDetailsButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: ${(p) => (p.$isMobile ? '1' : '0 0 auto')};
  height: ${(p) => (p.$isMobile ? '38px' : '34px')};
  padding: 0 14px;
  background: ${v2Color('#F2FAFA')};
  color: ${v2Color('#006169', 'text')};
  border: 1px solid ${v2Color('#A6C8CA')};
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const PostNowButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: ${(p) => (p.$isMobile ? '1' : '0 0 auto')};
  height: ${(p) => (p.$isMobile ? '38px' : '34px')};
  padding: 0 14px;
  background: ${v2Color('#006169')};
  color: #fff;
  border: 1px solid ${v2Color('#006169')};
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;
